import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import API_URL from '../../apiConfig';

import NavbarDash from '../../composants/NavbarDash'

function Dashboard(){

  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
        // Récupérer la session
        fetch(`${API_URL}/admin/session`, {
        credentials: 'include',
        method: "POST"
        })
        .then(res => {
            if (!res.ok) throw new Error('Non connecté');
            return res.json();
        })
        .then(data => setAdmin(data.admin))
        .catch(() => {
            // Si pas connecté → retour à login
            navigate('/');
        });
    }, [navigate]);

    return(
      <div className="d-flex min-vh-100">
        <NavbarDash />
        <main className="flex-grow-1" style={{ marginLeft: 'var(--sidebar-w)', backgroundColor: 'var(--bg-main)' }}>
          {/* Top Bar / Header */}
          <header className="bg-white border-bottom p-3 d-flex justify-content-between align-items-center sticky-top">
            <h2 className="h5 mb-0 fw-bold text-muted">Tableau de Bord</h2>
            {admin && (
              <div className="d-flex align-items-center gap-3">
                <div className="text-end d-none d-sm-block">
                  <p className="mb-0 fw-bold small">{admin.prenom} {admin.nom}</p>
                  <span className="text-success small" style={{ fontSize: '0.7rem' }}>● En ligne</span>
                </div>
                <img 
                  src={admin.linkImg || "https://ui-avatars.com/api/?name="+admin.nom} 
                  alt="profil" 
                  className="rounded-circle border" 
                  width="40" 
                  height="40" 
                  style={{ objectFit: 'cover' }}
                />
              </div>
            )} 
          </header>

          {/* Page Content */}
          <div className="p-4">
            <div className="animate__animated animate__fadeIn">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    );

}


export default Dashboard;